























































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import UserIcon from 'mdi-vue/AccountSearch';
import AddIcon from 'mdi-vue/Plus';
import CheckIcon from 'mdi-vue/Check';
import CloseIcon from 'mdi-vue/Close';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';
import api from '@/libs/api';
import Modal from '@/components/Modal.vue';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import TagInput from '@/components/TagInput.vue';
import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import SubHeader from '@/components/Table/SubHeader.vue';
import Cell from '@/components/Table/Cell.vue';
import Checkbox from '@/components/Checkbox.vue';
import Loader from '@/components/Loader.vue';
import Button from '@/components/Button.vue';
import Tab from '@/components/Tab/Tab.vue';
import SummaryBox from '@/components/SummaryBox.vue';
import SearchField from '@/components/SearchField.vue';
import SearchRow from '@/components/SearchRow.vue';
import Select from '@/components/Select.vue';
import numberFormat from '@/libs/numberFormat';
import FormInput from '@/components/FormInput.vue';
import {
  BankConfigCC, InvoiceCustomer, InvoiceCustomerResponse, InvoiceListProfileResponse,
  InvoiceProduct, InvoiceProductResponse, InvoiceProfile, User,
} from '@/libs/api.interfaces';
import { mapState } from 'vuex';
// eslint-disable-next-line import/no-cycle
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import dayjs from 'dayjs';

interface LabelValue {
  label: string;
  value: number;
}

interface InstallmentList {
  [id: string]: {
    bank: BankConfigCC;
    tenors: BankConfigCC[];
  };
}

@Component({
  components: {
    Modal,
    FormInput,
    LayoutTitle,
    LayoutContent,
    TagInput,
    Table,
    Row,
    Header,
    SubHeader,
    Cell,
    Checkbox,
    Loader,
    Button,
    Tab,
    SummaryBox,
    SearchField,
    SearchRow,
    Select,
    TableBody,
    ScrollbarWrapper,
    UserIcon,
    AddIcon,
    CheckIcon,
    CloseIcon,
  },
  data() {
    return {
      listItems: [
        {
          productName: '',
          quantity: '',
          price: '',
          total: '',
        },
      ],
    };
  },
  methods: {
    numberFormat,
  },
  computed: mapState(['user']),
})
export default class ReRequestEinvoice extends Vue {
  user!: {
    user: User;
  };

  merchantId = 0;

  profiles: InvoiceProfile[] = [];
  profileList: LabelValue[] = [];
  selectedProfile: LabelValue | null = null;
  currentProfile: InvoiceProfile | null = null;
  loadingProfile = true;

  showCustomerModal = false;
  loadingCustomer = false;
  customers: InvoiceCustomer[] = [];

  customerName = '';
  email = '';
  mailSubject = '';
  phoneNumber = '';
  address = '';

  transactionNumber = '';
  autoGenerateTransactionNumber = false;

  loadingProduct = false;
  productTemplate: InvoiceProduct[] = [];
  productKey = 1;
  products: {
    key: number;
    name: string | InvoiceProduct;
    quantity: string;
    price: string;
  }[]
    = [
      {
        key: 1,
        name: '',
        quantity: '1',
        price: '0',
      },
    ]

  hasCreditCardProfile = true;
  creditCardFullPayment = false;
  creditCardInstallment = false;
  installmentType = 'full';
  selectedInstallment: { [key: string]: boolean } = {};
  selectedInstallmentTenor: { [key: string]: boolean[] } = {};

  fullpayments: BankConfigCC[] = [];
  installments: InstallmentList = {} as InstallmentList;

  canSelectExpiration = true;
  expirationDays = [...new Array(8)].map((e, i) => ({ label: `${i} Day${(i) > 1 ? 's' : ''}`, value: i }));
  expirationHours = [
    { label: '30 Minutes', value: 0.5 },
    ...[...new Array(25)].map((e, i) => ({ label: `${i} Hour${i > 1 ? 's' : ''}`, value: i })),
  ];

  expirationDay = this.expirationDays[0];
  expirationHour = this.expirationHours[4];

  description = '';
  viaEmail = true;
  viaSMS = false;
  viaWA = false;

  showPreview = false;

  loadingSubmit = false;

  async getProfile() {
    try {
      this.loadingProfile = true;
      /* eslint-disable @typescript-eslint/camelcase */
      const { data } = await api.post<InvoiceListProfileResponse>('/easyinvoice/invoices_list_profile', {
        user_group: 5,
        merch_id: this.merchantId,
      });

      this.profiles = data.profile;
      this.profileList = data.profile.map((e, i) => ({
        label: e.name,
        value: i,
      }));

      if (data.config_store.config_cc.length === 0) {
        this.hasCreditCardProfile = false;
      }

      Object.entries(data.config_store.config_cc).forEach(([, item]) => {
        item.forEach((e) => {
          if (e.type === 'FULLPAYMENT') {
            this.fullpayments.push(e);
          } else {
            if (this.installments[e.bank_id] === undefined) {
              this.installments[e.bank_id] = {
                bank: e,
                tenors: [],
              };
            }
            this.installments[e.bank_id].tenors.push(e);
            this.selectedInstallmentTenor[e.bank_id] = [];
          }
        });
      });

      this.loadingProfile = false;
    } catch (err) {
      console.error(err);
    }
  }

  @Watch('selectedProfile')
  onProfileChange() {
    if (this.selectedProfile === null) return;

    const index = this.selectedProfile.value;
    const profile = this.profiles[index];
    this.currentProfile = profile;

    this.mailSubject = profile.subject_mail;

    this.canSelectExpiration = profile.expiration_time === '0';

    this.autoGenerateTransactionNumber = profile.generate_trxno === '1';

    this.getProducts();
  }

  @Watch('autoGenerateTransactionNumber')
  onAutoGenerateTransactionNumberChange() {
    if (this.autoGenerateTransactionNumber) {
      const numb = new Date().valueOf();
      const numb2 = Math.floor(Math.random() * 1000 + 1);
      this.transactionNumber = numb.toString() + numb2.toString();
    } else {
      this.transactionNumber = '';
    }
  }

  async getCustomer() {
    try {
      this.loadingCustomer = true;
      /* eslint-disable @typescript-eslint/camelcase */
      const { data } = await api.post<InvoiceCustomerResponse>('/easyinvoice/invoices_customer', {
        user_group: 5,
        merch_id: this.merchantId,
        user_id: this.user.user.id,
      });

      this.customers = data.data.data;
      this.loadingCustomer = false;
    } catch (err) {
      console.error(err);
    }
  }

  selectCustomer(index: number) {
    const customer = this.customers[index];
    this.customerName = customer.customer_name;
    this.email = customer.customer_email;
    this.phoneNumber = customer.customer_phone;
    this.address = customer.customer_address;
    this.showCustomerModal = false;
  }

  async getProducts() {
    try {
      this.loadingProduct = true;
      /* eslint-disable @typescript-eslint/camelcase */
      const { data } = await api.post<InvoiceProductResponse>('/easyinvoice/products', {
        user_group: 5,
        merch_id: this.merchantId,
        profile: this.currentProfile?.id,
        status: 1,
      });

      this.productTemplate = data.data.data;
      this.loadingProduct = false;
    } catch (err) {
      console.error(err);
    }
  }

  async submit() {
    try {
      this.loadingSubmit = true;
      /* eslint-disable @typescript-eslint/camelcase */

      const bank: {
        bank_id: string; config: {
          id: string;
          channel_id: string;
          tenor: number;
        }[];
      }[] = [];
      if (this.installmentType === 'select') {
        Object.entries(this.selectedInstallment).forEach(([id, selected]) => {
          if (selected) {
            bank.push({
              bank_id: id,
              config: [],
            });
          }
        });

        bank.forEach((e) => {
          const tenors = this.selectedInstallmentTenor[e.bank_id];
          tenors.forEach((t, index) => {
            const tenor = this.installments[e.bank_id].tenors[index];
            if (t) {
              e.config.push({
                id: tenor.id,
                channel_id: tenor.channel_id,
                tenor: tenor.tenor,
              });
            }
          });
        });
      } else {
        Object.entries(this.installments).forEach(([id, item]) => {
          bank.push({
            bank_id: id,
            config: item.tenors.map((e) => ({
              id: e.id,
              channel_id: e.channel_id,
              tenor: e.tenor,
            })),
          });
        });
      }

      const { data } = await api.post('/easyinvoice/invoices_create', {
        user_group: 5,
        profile_id: this.currentProfile?.id,
        merch_id: this.merchantId,
        user_id: this.user.user.id,
        nama: this.customerName,
        email: this.email,
        subject_mail: this.mailSubject,
        no_telpon: this.phoneNumber,
        address: this.address,
        transaction_number: this.transactionNumber,
        auto_transaction_number: this.autoGenerateTransactionNumber ? 'on' : undefined,
        productNamenl: this.productTemplate.length > 0
          ? this.products.map((e) => (e.name as InvoiceProduct).product_name)
          : [],
        productId: this.productTemplate.length > 0
          ? this.products.map((e) => (e.name as InvoiceProduct).product_id)
          : [],
        productName: this.productTemplate.length === 0
          ? this.products.map((e) => e.name)
          : [],
        productQuantity: this.products.map((e) => e.quantity),
        productPrice: this.products.map((e) => e.price),
        amount: this.totalAmount,
        is_fullpayment: this.creditCardFullPayment ? 1 : '',
        channel_fullpayment: this.fullpayments.length > 0 ? this.fullpayments[0].channel_id : undefined,
        id_fullpayment: this.fullpayments.length > 0 ? this.fullpayments[0].id : undefined,
        is_installment: this.creditCardInstallment ? 1 : undefined,
        select_installment: this.installmentType === 'full' ? 1 : 2,
        bank: this.creditCardInstallment ? bank : undefined,
        hours: this.expirationHour.value,
        endDate: this.expiration.format('YYYY-MM-DD HH:mm:ss'),
        description: this.description,
        mail_channel: this.viaEmail ? 'on' : undefined,
        sms_channel: this.viaSMS ? 'on' : undefined,
        wa_channel: this.viaWA ? 'on' : undefined,
      });

      this.loadingSubmit = false;
      this.showPreview = false;

      if (data.status === '01') {
        showToast(ToastType.FAILED, data.message, data.error.join(', '));
      } else if (data.status === '00') {
        showToast(ToastType.SUCCESS, 'Success', data.message);
      }
    } catch (err) {
      console.error(err);
    }
  }

  addProduct() {
    this.productKey += 1;
    this.products.push({
      key: this.productKey,
      name: '',
      quantity: '1',
      price: '0',
    });
  }

  deleteProduct(index: number) {
    this.products.splice(index, 1);
  }

  updateProductRow(index: number) {
    this.products[index].price = (this.products[index].name as InvoiceProduct).price.toString();
  }

  get totalAmount() {
    const amount = this.products.reduce(
      (total, current) => total + Number(current.price) * Number(current.quantity),
      0,
    );
    if (amount < 500000) {
      this.creditCardInstallment = false;
    }

    return amount;
  }

  get expiration() {
    let now = dayjs();
    if (this.canSelectExpiration) {
      now = now.add(this.expirationDay.value, 'day');
      now = now.add(this.expirationHour.value, 'hour');
    } else {
      now = now.add(Number(this.currentProfile?.expiration_time), 'minute');
    }
    return now;
  }

  mounted() {
    this.merchantId = this.user.user.merchant_id;
    this.getProfile();
    this.getCustomer();
  }
}
